import { useSelector } from 'react-redux';

import type { RootState } from '../types/state.types';

export function useSubId() {
  const subId = useSelector((state: RootState) => state.subscription.id);
  return subId;
}
